import { render, staticRenderFns } from "./TabListArea.vue?vue&type=template&id=54f00e96"
import script from "./TabListArea.vue?vue&type=script&lang=js"
export * from "./TabListArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports